<template>
  <TitleBox bgColor="#98dfe2e0" @skip="handleSkip" :videos="videos">
    {{ title }}
  </TitleBox>
</template>

<script>
import TitleBox from './TitleBox'
import mixin from './mixin'
import SvgIcon from '../SvgIcon'
import Anicss from '../Anicss'
import VideoPlayer from '../VideoPlayer'

const videos = [
  require('!file-loader!@/assets/video/正字與錯字_002.mp4'),
]

export default {
  mixins: [mixin('right-word')],
  components: {
    TitleBox,
  },
  data () {
    return {
      videos,
    }
  },
  mounted () {
  },
  methods: {
  },
}
</script>

<style lang="scss" module>
</style>
